import { UseMutationOptions, useMutation, useQueryClient } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { CURRICULUM_MASTER } from "../apiRoutes";

const mutateUpdateCurriculumMaster = async ({ id, data }: { id: string; data: FieldValues }) => {
  return await axiosAuth.put(`${CURRICULUM_MASTER}${id}`, data);
};

const useUpdateCurriculumMasterMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      id: string;
      data: FieldValues;
    },
    unknown
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: mutateUpdateCurriculumMaster,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({ queryKey: ["curriculumMaster"], exact: false });
      queryClient.invalidateQueries({ queryKey: ["curriculumMasterDetail", variables.id] });
      queryParams?.onSuccess?.(data, variables, context);
    },
    ...queryParams,
  });
};

export default useUpdateCurriculumMasterMutation;


